import RandingStyle1 from "../../randing/RandingStyle1";
import RandingStyle2Newcolor from "../../randing/RandingStyle2Newcolor";

function Randing257({ urlCode, urlCodeSettingId }) {
  return (
    <RandingStyle1
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      totalStep="2"
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/257/01.gif`}
      // img2Path={`${process.env.REACT_APP_CDN_BASE}/images/211/01.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/257/01.gif`} // 스텝 변경되는 이미지
      numberColor="#18646c"
      qOptionColor="teal"
      keepBTN={`${process.env.REACT_APP_CDN_BASE}/images/018/01_241120_04.png`}
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/018/02_241120_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
    />
  );
}

export default Randing257;
